var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('div',{staticClass:"col-12"},[_c('page-header',{attrs:{"page":_vm.page}})],1),(_vm.alerts.length > 0)?_c('div',{staticClass:"row mx-0"},[_c('div',{staticClass:"col-md-12"},[_c('div',{staticClass:"mt-5"},[_c('custom-carousel',{staticClass:"custom-carousel__extended",attrs:{"items":_vm.alerts,"size-per-slide":6}})],1)])]):_vm._e(),_c('div',{staticClass:"col-12 flip-cards-container"},[_vm._l((_vm.optionList),function(option,index){return _c('square-option',{key:index,attrs:{"option":option}})}),_c('square-option',{attrs:{"option":{
        title: 'Configuraciones',
        description: 'Mantenimiento de Configuraciones del Sistema',
        detail: 'detalle',
        icon: 'fas fa-cog',
        mainImage: './img/card-prov-remedy-req-management-hover.bc782098.svg',
        hoverImage:
          './img/card-prov-remedy-req-management-hover.bc782098.svg',
        needSelectedStudent: false,
        route: '/support/settings',
      }}})],2)])
}
var staticRenderFns = []

export { render, staticRenderFns }